export const convertFeet = (num,showInch) => {
    var inches1 = 0;
    var feet = Math.floor(num);
    var inches = Math.round((num - feet) * 12);
    if (inches > 0 && inches < 12) {
        inches1 = inches;//"0" + inches;
    }
    if (inches === 12) {
        feet = feet + 1;
        inches = 0;
     }
    var dimension = (feet > 0 && inches < 12 && inches !== 0) ? Math.abs(feet) + "'" + inches1 + '"' : (feet === 0) ? inches1 + '"' : Math.abs(feet) + "'"; 
 
    return dimension;
}